import { paymentServices } from '@/services/dashboard.service';
import { queryKeys } from '@/services/queryKeyFactory';
import { useQuery } from '@tanstack/react-query';
import React, { useContext } from 'react';
import { useAuth } from './AuthContext';
import { AUTH_STATUSES } from '@/constants';

const PlanRulesContext = React.createContext()

function PlanRulesProvider({ children }) {

    const { isAuthenticated } = useAuth();

    const { data: plans, isLoading: isLoadingPlans, isError: isErrorPlans } = useQuery({
        queryKey: queryKeys.planDetails(),
        queryFn: paymentServices.getPlanDetails,
        refetchOnWindowFocus: false,
        enabled: true
    })

    const { data: planRules, isLoading: isLoadingPlanRules, isError: isErrorPlanRules } = useQuery({
        queryKey: queryKeys.planRules(),
        queryFn: paymentServices.getPlanRules,
        enabled: !!isAuthenticated?.authStatus && (isAuthenticated?.status === AUTH_STATUSES.payment_done || isAuthenticated?.status === AUTH_STATUSES.active)
    })


    const rules = {
        canAccessRateParity: () => !!planRules?.plan_rules?.rate_parity,
        canExport: () => !!planRules?.plan_rules?.export,
        canAccessAdvanceAnalysis: () => !!planRules?.plan_rules?.advance_analytics,
        canCreateSchedule: () => !!planRules?.plan_rules?.schedule_run,
        canAccessAiInsights: () => !!planRules?.plan_rules?.ai_insights?.access,
        calculateAiInsightRefreshCount: (section) => {
            if (!section) return 0
            const remainingRefresh = planRules?.plan_rules?.ai_insights?.[section]
            return remainingRefresh ? remainingRefresh : 0
        },
        maxCompSets: planRules?.plan_rules?.maxCompsets,
        maxCompetitorsPerCompset: planRules?.plan_rules?.maxCompetitorsPerCompset,
        isPlanActive: planRules?.plan_info?.active_status,
        maxAiRefreshPerSection: planRules?.plan_rules?.ai_insights?.max_per_section
    }


    const value = { ...rules, isLoadingPlanRules, isErrorPlanRules, planRules, plans, isLoadingPlans, isErrorPlans }

    return (
        <PlanRulesContext.Provider value={value}>
            {children}
        </PlanRulesContext.Provider>
    );
}

export default PlanRulesProvider;

export const usePlans = () => {
    const context = useContext(PlanRulesContext);
    if (!context) {
        throw new Error("usePlans must be used within PlanRulesProvider");
    }
    return context
}